// GraphQL
import { gql, useFragment, useQuery } from "@apollo/client";
import { GET_FORM_QUERY } from "utilities/gravity-forms";

// Style
import style from "./gravity-form.module.scss";

// Constants
import { gravityFormBlock } from "@/constants/constants";

// Components
import Container from "@/components-layout/container/container";
import ModuleSettings from "@/components-modules/module-settings/module-settings";
import GravityForm from "@/components/gform/gravity-form";

export default function GravityFormModule({ module }) {
  // - Fragment
  const { complete, data } = useFragment({
    fragment: GravityFormModule.fragments.module,
    fragmentName: "GravityFormFragment",
    from: {
      __typename: module.__typename,
      id: module.id,
    },
  });

  if (!complete) {
    return;
  }

  const form = useQuery(GET_FORM_QUERY, {
    variables: { databaseId: data.form[0] },
  });

  if (form.loading) {
    return <p>Loading...</p>;
  }
  if (form.error) {
    return;
  }

  // -- If Hide Module -- //
  if (data.gravityFormBlockModuleSettings.hideModule) {
    return;
  }

  // - Variables
  const moduleSettings = data.gravityFormBlockModuleSettings;

  return (
    <section
      id={moduleSettings.module_id}
      className={`moduleGravityForm ${style.moduleGravityForm} ${
        moduleSettings.classes ? moduleSettings.classes : ""
      }`}
    >
      <ModuleSettings settings={moduleSettings} />

      <Container>
        <GravityForm form={form.data?.gfForm} />
      </Container>
    </section>
  );
}

GravityFormModule.fragments = {
  module: gql`
    fragment GravityFormFragment on ${gravityFormBlock} {
      id
      __typename
      form
      
      # -- Module General Settings
      gravityFormBlockModuleSettings {
        ...ModSetFragment @unmask(mode: "migrate")
      }
    }
    ${ModuleSettings.fragments.entry}
  `,
};
